export default __webpack_public_path__ + "static/media/default.d3256048fa45ba44c7ed0724b8e65736.svg";